import React from "react";

/**
 * Render a string with markdown-style **bold** support.
 * Splits on `**text**` and renders matches as <strong>.
 */
export function renderWithBold(text, strongStyle = {}) {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**") && part.length > 4) {
      return (
        <strong key={i} style={strongStyle}>
          {part.slice(2, -2)}
        </strong>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
